export class GcConnectionInfo {

    carrier: string;
    identifier: string;
    qrCodeUrl: string;

    constructor(info?: any) {
        if (info != null) {
            this.carrier = info.carrier;
            this.identifier = info.identifier;
            this.qrCodeUrl = info.qrCodeUrl;
        }
    }
}